import { useNavigate } from "react-router-dom";
import { avartar, favicon } from "../constants/imports";

export default function(){
var navigate=useNavigate()



    return(<>
    
    <div className=" flex  items-center  flex-col  main-cont bg-lightBlue">
    <h2 className="place-self-start	m-4 text-[17px] ">IMEDIX</h2>

        <img width='90%' src={avartar} />
 
<div className="w-full p-4 flex-col flex justify-start ">
    <h2>Welcome</h2>
<p className=" text-black font-thin ">Your health is our top priority. Discover more
about how it functions</p>
<button className="  rounded p-2 bg-customBlue text-white font-semibold"> Get started</button>
<button onClick ={()=>navigate('/chat')} className="  rounded mt-2 p-2 border-2 border-customBlue bg-[#00000000] text-black font-semibold"> Skip</button>


</div>
    </div>
        
    
    </>)
}